var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useSelector } from 'react-redux';
import { BlameLogType } from '@debbie/common/dist/blamelog';
import AddressInput from '../../AddressInput';
import UserInfoEntity from './UserInfoEntity';
const UserAddress = (props) => {
    const { details } = props.user;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(UserInfoEntity, { title: lang.debtorInfo.address, value: details.address, hist: details.addressHist, onChange: (val) => __awaiter(void 0, void 0, void 0, function* () { }), renderValue: (val) => (val && val.address && (React.createElement(React.Fragment, null,
            val.address,
            val.coAddress && `, c/o ${val.coAddress}`,
            ",",
            React.createElement("br", null),
            val.zipcode,
            " ",
            val.city,
            val.country && (React.createElement(React.Fragment, null,
                ",",
                React.createElement("br", null),
                " ",
                val.country))))) || React.createElement("span", { style: { opacity: 0.5 } }, lang.debtorInfo.noAddr), renderEditor: (selectedValue) => (React.createElement(AddressInput, { address: details.address, onChange: (address) => __awaiter(void 0, void 0, void 0, function* () {
                if ((address && address.address) || address === null) {
                    selectedValue(address);
                    yield props.patchUser({
                        address,
                    }, {
                        details: address,
                        type: BlameLogType.DebtorUpdateAddress,
                    });
                }
            }), notUpdateOnEditingStateChange: true })), removable: true }));
};
export default UserAddress;
//# sourceMappingURL=UserAddress.js.map